import { Injectable } from '@angular/core';
import { ApiService } from './api.base.service';

export interface AlertConfig {
  thresholdMinutes: number;
  jobFrequencyMinutes: number;
  isEnabled: boolean;
}

export interface PendingSignatureUser {
  name: string;
  email: string;
  minutesSinceRequest: number;
}

export interface PendingSignaturesPanelItem {
  documentProcessId: number;
  constancyType: string;
  usersWithPendingSignature: PendingSignatureUser[];
}

export interface PagedPendingSignatures {
  items: PendingSignaturesPanelItem[];
  pagination: { totalCount: number; currentPage: number; pageSize: number };
}

@Injectable({ providedIn: 'root' })
export class AlertConfigService {
  private readonly baseUrl = 'api/alert-config';
  private readonly pendingUrl = 'api/pending-signatures';

  constructor(private apiService: ApiService) {}

  async getConfig(): Promise<AlertConfig> {
    return this.apiService.get<AlertConfig>(this.baseUrl);
  }

  async updateConfig(config: AlertConfig): Promise<void> {
    await this.apiService.put<void>(this.baseUrl, config);
  }

  async getPendingSignatures(page: number, pageSize: number): Promise<PagedPendingSignatures> {
    return this.apiService.get<PagedPendingSignatures>(`${this.pendingUrl}/${page}/${pageSize}`);
  }
}
